import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function SEO({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage = "https://soloconnect.in/preview.png",
  ogType = "website",
  twitterCard = "summary_large_image",
  twitterTitle,
  twitterDescription,
  twitterImage,
  canonicalUrl,
}) {
  const location = useLocation();

  useEffect(() => {
    // 1. Update Title
    if (title) {
      document.title = title;
    }

    const updateMetaTag = (nameAttr, value, isProperty = false) => {
      if (!value) return;
      const selector = isProperty
        ? `meta[property="${nameAttr}"]`
        : `meta[name="${nameAttr}"]`;
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute("content", value);
      } else {
        element = document.createElement("meta");
        if (isProperty) {
          element.setAttribute("property", nameAttr);
        } else {
          element.setAttribute("name", nameAttr);
        }
        element.setAttribute("content", value);
        document.head.appendChild(element);
      }
    };

    // 2. Update Basic Meta Tags
    updateMetaTag("description", description);
    if (keywords) {
      updateMetaTag("keywords", keywords);
    }

    // 3. Update Open Graph Tags
    const ogTitleValue = ogTitle || title;
    const ogDescValue = ogDescription || description;
    const currentUrl = canonicalUrl || `https://soloconnect.in${location.pathname}`;

    updateMetaTag("og:title", ogTitleValue, true);
    updateMetaTag("og:description", ogDescValue, true);
    updateMetaTag("og:type", ogType, true);
    updateMetaTag("og:url", currentUrl, true);
    if (ogImage) {
      updateMetaTag("og:image", ogImage, true);
    }

    // 4. Update Twitter Tags
    updateMetaTag("twitter:card", twitterCard);
    updateMetaTag("twitter:title", twitterTitle || ogTitleValue);
    updateMetaTag("twitter:description", twitterDescription || ogDescValue);
    if (twitterImage || ogImage) {
      updateMetaTag("twitter:image", twitterImage || ogImage);
    }

    // 5. Update Canonical Tag
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute("href", currentUrl);
    } else {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", currentUrl);
      document.head.appendChild(canonicalLink);
    }
  }, [
    title,
    description,
    keywords,
    ogTitle,
    ogDescription,
    ogImage,
    ogType,
    twitterCard,
    twitterTitle,
    twitterDescription,
    twitterImage,
    canonicalUrl,
    location.pathname,
  ]);

  return null;
}
